import { FilterOption } from "@/models/base/Filter";

export function formatSelectedOptionTooltipHtml(option: FilterOption): string {
  const lines = [option.label];
  if (option.aliases && option.aliases.length > 0) {
    lines.push(`Inkluderer også: ${option.aliases.join(", ")}`);
  }
  return lines.join("<br />");
}

/** Wider popover so long ministry names and alias lists can wrap instead of truncating. */
export const MINISTRY_FILTER_POPOVER_CLASS =
  "w-[min(28rem,calc(100vw-2rem))] p-0";
